import { useEffect } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import { setFiltering } from '../redux/actions/filteringActions';
import { setPovrchy } from '../redux/actions/prvkyActions';
import Filtering from '../comp/Filtering';
import ListingPovrchu from '../comp/ListingPovrchu';
import URLEndPointBE from '../comp/URLEndPointBE';
import FilteringToggleAdminAll from '../comp/FilteringToggleAdminAll';

function SeznamPovrchu() {
    const { keycloak, initialized } = useKeycloak();
    let { params } = useParams();
    const dispatch = useDispatch();
        //potential succ from insertion/edit redirect
        const {state} = useLocation();
        console.log(state)
    const povrchy = useSelector((state: any) => state.allPrvky.povrchy); 
    const filtPovrchy = useSelector((state: any) => state.filtStates.filtPovrchy);
    const visibility = useSelector((state: any) => state.filtStates.visibility);
    const pouziti = useSelector((state: any) => state.miscDicts.pouziti);
 
    const filtering_list = Object.entries(filtPovrchy).map((filt: any) => (filt[1]===true)&&filt[0])
    let pouziti_list_ids = pouziti.filter((pouz: any) => {
        if (visibility === 'NORMAL') {
          return pouz.pouzitibool === 1;
        } else if (visibility === 'ALL') {
          return pouz.pouzitibool === 1 || pouz.pouzitibool === 0;
        }
      })
    .reduce((list: any, pouz: any)=>([...list, pouz.key]),[]);

    let povrchy_filtered = povrchy.filter((povr: any) => (povr.povrchyPouziti!=null)&&(povr.povrchyPouziti.some((pouz: any) => filtering_list.includes(pouz.rodina_kod)&&pouziti_list_ids.includes(pouz.pouziti_id))))
    //TODO rewrite debug to function if povrchy!=[]
    /*
    console.log("<SeznamPovrchu debug of vars")
    console.log("povrchy")
    console.log(povrchy)
    */
    /*
    console.log("filtPovrchy")
    console.log(filtPovrchy)
    console.log("pouziti")
    console.log(pouziti)
    console.log("filtering_list")
    console.log(filtering_list)
    console.log("pouziti_list_ids")
    console.log(pouziti_list_ids)
    console.log("povrchy_filtered")
    console.log(povrchy_filtered)
    console.log("-END-")
    */
    
    const FetchPovrchy = async () => {
        const response: any = await axios
            .get(URLEndPointBE+`/listing/povrchy`)
            .catch((error) => {
                console.log("Err", error)
            });
        return response.data;    
        //dispatch(setPovrchy(response.data));
    }
    const FetchSetRodinyPovrchu = async () => {
        const _rodiny_povrchu: any = await axios
            .get(URLEndPointBE+`/dict-misc/rodiny-povrchu`)
            .catch((error) => {
              console.log("Err rodiny povrchu", error)
            });          
        let _rodiny_povrchu_space = _rodiny_povrchu.data.reduce((objVals: any, v: any)=>({...objVals, [v.kod]: true}), {})
        dispatch(setFiltering({flag: "POVRCHY", filtering: _rodiny_povrchu_space})) 
    }

    const FilteringAllFalseCombined = async (params: any) => {
        const _rodiny_povrchu: any = await axios
            .get(URLEndPointBE+`/dict-misc/rodiny-povrchu`)
            .catch((error) => {
              console.log("Err rodiny povrchu", error)
            });
        let _rodiny_povrchu_state = _rodiny_povrchu.data.reduce((objVals: any, v: any)=>({...objVals, [v.kod]: false}), {})
        for(let p of params) {
            _rodiny_povrchu_state[p]=true;
        }
        dispatch(setFiltering({flag: "POVRCHY", filtering: _rodiny_povrchu_state}))
    } 

    useEffect(() => {
        dispatch(setMenuSelected("povrchy"));

        const povrchy = FetchPovrchy();
        Promise.resolve(povrchy).then((result) => {
            dispatch(setPovrchy(result));
        });

        if(typeof(params) !== 'undefined') {
            let opt_params = params.split(';')
            FilteringAllFalseCombined(opt_params)
        } else {
            FetchSetRodinyPovrchu();
        }
    }, [])

    return (
        <Container>
            {/*/@ts-ignore*/}
            {(state?.succ)?<Row className={"succRow"}>
                {/*/@ts-ignore*/}
                <span className={"succTxtInside"}>Úspěch - {state?.type} {state?.item} </span>
            </Row>:<></>}
            <Row className="prvkyControl printHide">
                <Col className='boxBorderAround'>
                    <span className='alignLeft'><h2><b>SEZNAM POVRCHŮ</b></h2></span>
                    {keycloak.authenticated && (
                    <Link className="navRemoveUnderscoreInLinkA" to="/povrchy/new">
                           <span className="katBtnStyle">NOVÝ ZÁZNAM</span>
                       </Link>
                     )}
                </Col>
                <Col className='boxBorderAround'>
                    <Filtering caption="VÝBĚR DLE POUŽITÍ" flag="POVRCHY" param={filtPovrchy}/>
                    { (keycloak.authenticated)
                        ? <FilteringToggleAdminAll visibility={visibility}/>
                        : <></> }
                </Col>
            </Row>
            {/*if logged - display everything, else viditelnost=1 verejnost*/}
            { (keycloak.authenticated)
              ? <ListingPovrchu povrchy={povrchy_filtered}/>
              : <ListingPovrchu povrchy={povrchy_filtered.filter((pov: any)=> pov.viditelnost==1)}/> }
        </Container>
    )
};
export default SeznamPovrchu